import React from 'react';
import { INavigationItemProps, intoNavigationItems, NavigationItem } from '../NavigationItem';
import { createDefaultGlobalNavigation, DefaultHomeLink } from './createDefaultGlobalNavigation';
import { FlexRow } from '../../FlexRow';
import { MenuItemContent } from './MenuItemContent';
import { eAccessControlUserType } from '../../../enums/eAccessControlUserType';
import { notEmpty } from '../../../utilities/notEmpty';
import { clientUrls } from '../../../rest/ClientUrlFactory';
import { Header } from 'ui-toolkit/components/Header';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { getDefaultJWTCookie } from 'components/accessControl/getSpruceJWTCookie';

export interface IGlobalNavigationProps {
  isLogoLink?: boolean;
  showActions?: boolean;
  children?: React.ReactElement<INavigationItemProps>[];
  profile?: React.ReactNode;
  active?: string;
  onClick?: (href?: string) => void;
  onHomeClick?: () => void;
}

export const GlobalNavigation: React.FC<IGlobalNavigationProps> = ({
  active,
  children,
  isLogoLink = true,
  onClick,
  profile,
  showActions = true,
}) => {
  const userType = useGetUserType();

  const isAdministration = useHasPermissions([ePermissions.AuthIdentityRead]);
  const defaultItems = getDefaultJWTCookie() ? createDefaultGlobalNavigation(userType, isAdministration) : [];
  const logoLink = isLogoLink && getDefaultJWTCookie() ? DefaultHomeLink(userType) : '';

  const menu = [eAccessControlUserType.Vendor].includes(userType)
    ? undefined
    : [
        {
          children: <MenuItemContent>Open new order</MenuItemContent>,
          to: clientUrls.urlFor.createNewOrder(userType),
        },
        userType === eAccessControlUserType.Admin
          ? {
              children: <MenuItemContent>Add new lender</MenuItemContent>,
              to: clientUrls.urlFor.lenderCompanyCreate(),
            }
          : null,
      ].filter(notEmpty);

  const itemsToUse = children || defaultItems.map(intoNavigationItems);
  const navigationItems = itemsToUse.map((t, i) => (
    <NavigationItem onClick={onClick} {...t.props} key={i} isActive={t.props.isActive || t.props.text === active} />
  ));

  return (
    <Header
      actionItems={menu}
      profile={profile}
      logoLink={logoLink}
      showAuthenticatedControls={!!getDefaultJWTCookie()}
    >
      {getDefaultJWTCookie() ? navigationItems : null}
      <FlexRow verticalAlign={'center'}></FlexRow>
    </Header>
  );
};

GlobalNavigation.propTypes = {
  onClick: (props: IGlobalNavigationProps) =>
    props.children && props.onClick ? new Error('Child component should have onClick function.') : null,
};
